
import { Button, Dialog, EmptyState, Icon, Icons, Intent, List, ListItem, Spinner } from "construct-ui";
import PosmModel from "../../models/posm/posm.model";
import ViewBase from "../../views/view-base.view";
import QueryListComponent from "../query-list/query-list.component";
import GoodsLevelHierarchyComponent from "./goods-level-hierarchy.component";


export default function SelectGoodsComponent() {
  ViewBase.call(this);
  const title = "Goods Selection"
  const TITLE_SEPARATOR = ', ';
  let onSelect = () => { console.log("Goods Selected"); }
  let isDialogOpen = false;
  let closeDialog = () => { isDialogOpen = false; }
  let openDialog = () => { isDialogOpen = true; }
  let uiListHeight = "300px";
  let goodsList = [];
  let defaultFilter = {
    basicModel: null,
    selectedGoodsLevelList: [],
    pageSize: 10,
    pageIndex: 1
  }
  let filter = structuredClone(defaultFilter);
  let isSearchingGoods = false;
  let allGoodsSearchTotal = 0;
  let isGoodsPageEnd = false;
  const maximumValidator = {
    max: 5,
    maxErrorMsg: null,
    get isExceed() {
      return this.maxErrorMsg ? true : false;
    }
  }
  const renderTitle = (selectedItems) => {
    if (selectedItems?.length > 0) {
      return selectedItems.map(item => item.name).join(TITLE_SEPARATOR);
    }

    return '';
  }
  const renderLabel = (selectedItems) => {
    if (selectedItems?.length > 0) {
      if (selectedItems.length <= 3) {
        return selectedItems.map(item => item.name).join(', ');
      }

      return `${selectedItems.length} ${this.getText("LT00000308", "items selected")}`;
    }
    return '';
  }
  let clearFilter = () => {
    filter = structuredClone(defaultFilter);
    searchGoodsModelList();
  }
  let searchGoodsModelList = () => {
    filter.pageIndex = 1;
    goodsList = [];
    getGoodsModelList();
  }
  let getGoodsModelList = () => {
    isSearchingGoods = true;
    let request = {
      levelCodeList: filter.selectedGoodsLevelList,
      basicModel: filter.basicModel,
      pageSize: filter.pageSize,
      pageIndex: filter.pageIndex
    }
    PosmModel.getPosmMasterModel(request)
      .then(res => {
        goodsList = [...goodsList, ...res.data];
        isGoodsPageEnd = res.pageIndex * res.pageSize >= res.total;
        allGoodsSearchTotal = res.total;
      })
      .finally(() => {
        isSearchingGoods = false;
      })
  }
  let deselectGoods = (selectedItems, id) => {
    let idx = selectedItems.findIndex(s => s.id === id);
    if (idx > -1) {
      selectedItems.splice(idx, 1);
      onSelect(selectedItems);
    }
  }
  let clearSelectedGoods = () => {
    onSelect([]);
  }
  return {
    oninit: (vnode) => {
      if (vnode.attrs.onSelect)
        onSelect = vnode.attrs.onSelect
    },
    view: ({
      attrs: {
        selectedItems,
        required = false
      }
    }) => {
      return [
        m('.select-input-component.d-flex.gap-4.justify-content-between.align-items-center.form-control.form-control-bg.cursor-pointer', { onclick: openDialog },
          m('input.flex-fill.text-start.ps-0', {
            type: 'text',
            style: {
              width: 'inherit',
              'overflow-x': 'hidden',
              'text-overflow': 'ellipsis',
              border: 'none',
              background: 'transparent'
            },
            oninput: false,
            autocomplete: 'off',
            placeholder: this.getText("LT00000719", "No items selected"),
            title: renderTitle(selectedItems),
            value: renderLabel(selectedItems),
            required: required
          }),
          m(Icon,
            {
              name: Icons.LIST,
              intent: Intent.PRIMARY,
              onclick: openDialog
            }
          )
        ),
        m(Dialog,
          {
            title,
            class: 'cui-dialog-xxl',
            closeOnOutsideClick: false,
            isOpen: isDialogOpen,
            onClose: closeDialog,
            content: m("div",
              // Search section
              m('.card.mb-3.p-3',
                m('.card-body',
                  m('.row.g-4.align-items-end',
                    m('.col-md-4',
                      m('label.form-label', this.getText("LT00001218", "Item Name")),
                      m('input.form-control[type=text]', {
                        placeholder: this.getText("LT00001218", "Item Name"),
                        onchange: e => { filter.basicModel = e.target.value; },
                        value: filter.basicModel,
                      })
                    ),
                    m('.col-md-4',
                      m('label.form-label', this.getText('LT00001208', 'Goods Level'),

                      ),
                      m(GoodsLevelHierarchyComponent, {
                        onChange: (r) => { filter.selectedGoodsLevelList = r },
                        selectedItems: filter.selectedGoodsLevelList
                      })
                    ),
                    m('.col-12',
                      m('.d-flex.justify-content-end.gap-2',
                        m(Button, {
                          label: this.getText("LT00000001", "Search"),
                          intent: Intent.PRIMARY,
                          loading: false,
                          onclick: searchGoodsModelList,
                        }),
                        m(Button, {
                          label: this.getText("LT00000031", "Clear"),
                          intent: Intent.PRIMARY,
                          outlined: true,
                          onclick: clearFilter
                        }),
                      ),
                    )
                  )
                ),
                // Result section & selected items section
                m('.row.g-4',
                  m('.col-md-6',
                    m('.card',
                      m('.card-body',
                        m('.position-relative', { style: { height: uiListHeight } },
                          (goodsList?.length > 0)
                            ? m(QueryListComponent, {
                              items: goodsList,
                              itemKey: 'id',
                              itemValue: 'name',
                              multiple: true,
                              style: { height: uiListHeight },
                              selectedItems: selectedItems,
                              max: maximumValidator.max,
                              onSelect: (r, error) => {
                                //selectedGoodsList = r;
                                maximumValidator.maxErrorMsg = error;
                                onSelect(r);
                              },
                              onInfiniteScroll: () => {
                                if (!isSearchingGoods && !isGoodsPageEnd) {
                                  filter.pageIndex++;
                                  getGoodsModelList();
                                  m.redraw();
                                }
                              }
                            })
                            : m(EmptyState, {
                              icon: Icons.SEARCH,
                              content: this.getText("LT00000317", "No results found"),
                              fill: true,
                              style: 'color: #B5B5B5',
                            })
                        ),
                        isSearchingGoods && m(Spinner, { fill: true, background: true, active: true })
                      )
                    ),
                    m('.d-flex.justify-content-between',
                      m(`.invalid-feedback${maximumValidator.isExceed ? ".visible" : ".invisible"}`, {
                        style: {
                          display: "block",
                          width: "auto",
                        }
                      }, maximumValidator.maxErrorMsg),
                      m('span.mt-1',
                        { style: 'font-size: 0.875em;' },
                        `${goodsList && goodsList.length > 0 ? goodsList.length : '0'} / ${allGoodsSearchTotal} ${this.getText("LT00000364", "record(s)")}`
                      )
                    ),

                  ),
                  m('.col-md-6',
                    m('.card',
                      m('.card-body',
                        m('.position-relative', { style: `min-height: ${uiListHeight}` },
                          selectedItems && selectedItems.length > 0 ?
                            m(List, {
                              interactive: true,
                              style: {
                                height: uiListHeight
                              }
                            },
                              selectedItems.map(item => m(ListItem, {
                                label: item.name,
                                contentRight: m(Icon, {
                                  name: Icons.X,
                                  intent: Intent.NEGATIVE,
                                  onclick: e => {
                                    deselectGoods(selectedItems, item.id);
                                  }
                                })
                              })))
                            :
                            m(EmptyState, {
                              icon: Icons.BOX,
                              content: this.getText("LT00001209", "No goods selected"),
                              fill: true,
                              style: 'color: #B5B5B5',
                            }),
                        )
                      )
                    ),
                    m('.d-flex.justify-content-end.align-items-center.gap-3',
                      m('a.btn.btn-link.p-0.mt-1', { onclick: clearSelectedGoods }, this.getText("LT00000545", "Clear selections")),
                      m('span.mt-1',
                        { style: 'font-size: 0.875em;' },
                        ((selectedItems ? selectedItems.length : '0') + ' ' + this.getText("LT00000364", "record(s)"))
                      )
                    )
                  )
                )

              ))

          })]
    }
  }
}
